export default __webpack_public_path__ + "static/media/mobile_phone.7290b8c1.png";